/*
 *
 * RPSavingIllustrationPage constants
 *
 */

export const CHANGE_LIFE_ASSURED_ACTION =
  'app/RPSavingIllustrationPage/CHANGE_LIFE_ASSURED_ACTION';
export const SET_PRODUCT_CONFIG_ACTION =
  'app/RPSavingIllustrationPage/SET_PRODUCT_CONFIG_ACTION';
export const SET_COVERAGES_LIST_ACTION =
  'app/RPSavingIllustrationPage/SET_COVERAGES_LIST_ACTION';
export const SET_COVERAGES_LIST2_ACTION =
  'app/RPSavingIllustrationPage/SET_COVERAGES_LIST2_ACTION';
export const GET_GC_CONFIG_ACTION =
  'app/RPSavingIllustrationPage/GET_GC_CONFIG_ACTION';
export const SET_GC_CONFIG_ACTION =
  'app/RPSavingIllustrationPage/SET_GC_CONFIG_ACTION';
export const CREATE_QUOTE_ACTION =
  'app/RPSavingIllustrationPage/CREATE_QUOTE_ACTION';
export const CALCULATE_QUOTE_ACTION =
  'app/RPSavingIllustrationPage/CALCULATE_QUOTE_ACTION';
export const SET_QUOTE_ACTION = 'app/RPSavingIllustrationPage/SET_QUOTE_ACTION';
export const SET_CALCULATION_ACTION =
  'app/RPSavingIllustrationPage/SET_CALCULATION_ACTION';
export const ADD_POLICY_OWNER_ACTION =
  'app/RPSavingIllustrationPage/ADD_POLICY_OWNER_ACTION';
export const GET_QUOTE_ACTION = 'app/RPSavingIllustrationPage/GET_QUOTE_ACTION';
export const UPDATE_STATUS_ACTION =
  'app/RPSavingIllustrationPage/UPDATE_STATUS_ACTION';
export const SET_QUOTE_DETAILS_ACTION =
  'app/RPSavingIllustrationPage/SET_QUOTE_DETAILS_ACTION';
export const SET_APPLICATION_ID_ACTION =
  'app/RPSavingIllustrationPage/SET_APPLICATION_ID_ACTION';
export const EMAIL_PDF_ACTION = 'app/RPSavingIllustrationPage/EMAIL_PDF_ACTION';
export const CREATE_APPLICATION_ACTION =
  'app/RPSavingIllustrationPage/CREATE_APPLICATION_ACTION';
export const SET_PTV_VERSION_ACTION =
  'app/RPSavingIllustrationPage/SET_PTV_VERSION_ACTION';
export const SET_ERROR_ACTION = 'app/RPSavingIllustrationPage/SET_ERROR_ACTION';
export const RESET_ACTION = 'app/RPSavingIllustrationPage/RESET_ACTION';
export const GET_FIA_ACTION = 'app/RPSavingIllustrationPage/GET_FIA_ACTION';
export const SET_FIA_ACTION = 'app/RPSavingIllustrationPage/SET_FIA_ACTION';
export const SET_BI_TABLE_VALUES_ACTION =
  'app/RPSavingIllustrationPage/SET_BI_TABLE_VALUES_ACTION';
export const SET_BI_TABLE_VALUES_ACTION1 =
  'app/RPSavingIllustrationPage/SET_BI_TABLE_VALUES_ACTION1';
export const CLONE_QUOTE_ACTION =
  'app/RPSavingIllustrationPage/CLONE_QUOTE_ACTION';
export const SET_CLONE_STATUS_ACTION =
  'app/RPSavingIllustrationPage/SET_CLONE_STATUS_ACTION';
export const SET_BI_PDF_ACTION =
  'app/RPSavingIllustrationPage/SET_BI_PDF_ACTION';

export const SET_BI_PDF_ACTION1 =
  'app/RPSavingIllustrationPage/SET_BI_PDF_ACTION1';
export const SET_CONFIG_NAME_ACTION =
  'app/RPSavingIllustrationPage/SET_CONFIG_NAME_ACTION';
export const SET_EMAIL_SENT_ACTION =
  'app/RPSavingIllustrationPage/SET_EMAIL_SENT_ACTION';

export const SET_EMAIL_ERROR_MESSAGE_ACTION =
  'app/RPSavingIllustrationPage/SET_EMAIL_ERROR_MESSAGE_ACTION';

export const SET_COVERAGES2_ACTION =
  'app/RPSavingIllustrationPage/SET_COVERAGES2_ACTION';
export const SET_PRODUCT_CODE_ACTION =
  'app/RPSavingIllustrationPage/SET_PRODUCT_CODE_ACTION';
